/**
 * As this file is reused in several other files, try to keep it lean and small.
 * Importing other npm packages here could lead to needlessly increasing the client bundle size, or end up in a server-only function that don't need it.
 */

export const publicAlgoliaAppId = assertValue(
	process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
	'Missing environment variable: NEXT_PUBLIC_ALGOLIA_APP_ID',
);

export const algoliaAdminApiKey = process.env.ALGOLIA_ADMIN_API_KEY;

export const algoliaSanityWebhookSecret =
	process.env.ALGOLIA_SANITY_WEBHOOK_SECRET;

export const algoliaSearchOnlyKey = assertValue(
	process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_ONLY_KEY,
	'Missing environment variable: NEXT_PUBLIC_ALGOLIA_SEARCH_ONLY_KEY',
);

export function assertValue<T>(v: T | undefined, errorMessage: string): T {
	if (v === undefined) {
		throw new Error(errorMessage);
	}

	return v;
}
